import {
  IdentityMelcoModelsGenericList1MelcoModelsProductListItem,
  IdentityMelcoModelsProductListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
//  import { useTranslation } from "react-i18next";

type DisplayProductsDropDownProps = {
  defaultProducts: IdentityMelcoModelsGenericList1MelcoModelsProductListItem;
  callbackFn: any;
};

export const DisplayProductsDropDown: React.FC<
  DisplayProductsDropDownProps
> = ({ defaultProducts, callbackFn }) => {
  const { t } = useTranslation();

  return (
    <>
      <SelectField
        name="product_code"
        label={t("licenses.basic.search.product.title")}
        options={(defaultProducts.list ?? []).map(
          (product: IdentityMelcoModelsProductListItem) => {
            return {
              label: product.name!,

              value: product.code!,
              product: product,
            };
          }
        )}
        showSearch
        optionFilterProp="label"
        onChange={(value, product) => callbackFn(value, product)}
      />
    </>
  );
};
